module.exports = __webpack_public_path__ + "static/img/18.f6c09b66.png";